<template>
	<div class="conteudo no-print">
		<flCabecalhoForm
			:msg="_traducao('global', 'obrigatorio')"
			cls="print-titulo-form-20"
			:texto="_traducao('global', 'enderecoResidencial')"
		/>
		<fl-endereco
			tipo="residencial"
			ref="endereco_residencial"
			@dados-endereco-residencial="
				(item) => {
					form.dados_endereco_residencial = item
				}
			"
		/>

		<flCabecalhoForm
			:msg="_traducao('global', 'obrigatorio')"
			cls="print-titulo-form-20"
			:texto="_traducao('global', 'enderecoFuncional')"
		/>
		<fl-endereco
			tipo="funcional"
			ref="endereco_funcional"
			@dados-endereco-funcional="
				(item) => {
					form.dados_endereco_funcional = item
				}
			"
		/>

		<fl-dados-adicionais
			:id="id"
			ref="dados_adicionais"
			@dados-adicionais="
				(obj) => {
					;(form.dados_adicionais = obj.form),
						(form.dados_emergencia = obj.dados),
						(form.dados_contato_emergencial = obj.contato),
						(form.dados_endereco_emergencial = obj.endereco),
						(form.tipo = obj.tipo)
				}
			"
			:bases="bases"
			:postos="postos"
			:cargos="cargos"
			:menu="menu"
			:estatal="estatal"
			:orgaos-apoiados="orgaosApoiados"
			:orgaos="orgaos"
			:funcoes="funcoes"
			:fabricantes="fabricantes"
			:habilitacoes="habilitacoes"
			:licencas="licencas"
			:modelos="modelos"
		/>
	</div>
</template>
<script>
import flDadosAdicionais from './dados-adicionais.vue'
import flEndereco from '../../../../../components/endereco/main.vue'
export default {
	props: {
		id: {
			type: [String, Number]
		},
		bases: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		cargos: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		postos: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		menu: {
			default: true,
			type: Boolean,
			require: false
		},
		orgaosApoiados: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		orgaos: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		funcoes: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		fabricantes: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		habilitacoes: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		licencas: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		modelos: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		estatal: {
			default: true,
			type: Boolean,
			require: false
		}
	},

	components: {
		flDadosAdicionais,
		flEndereco
	},
	data() {
		return {
			form: {
				dados_endereco_residencial: {},
				dados_endereco_funcional: {},

				dados_endereco_emergencial: {
					bairro: '',
					cep: '',
					cidade: '',
					complemento: '',
					estado: '',
					logradouro: '',
					numero: ''
				},

				dados_emergencia: {
					alergia: '',
					fator_rh: '',
					tipo_sanguineo: ''
				},

				dados_adicionais: {
					cargo: '',
					data_nascimento: '',
					masp: '',
					nome_guerra: '',
					posto_graduacao: '',
					sgpe: '',
					id_orgao: '',
					base_contratual: [
						{
							id: 0,
							id_base: '',
							data: '',
							excluir: '0'
						}
					],
					funcao: [
						{
							id: 0,
							id_perfil: '',
							id_funcao: '',
							id_fabricante: '',
							id_modelo: '',
							data: '',
							id_licenca: '',
							numero_licenca: '',
							id_habilitacao: '',
							excluir: '0'
						}
					]
				},

				dados_contato_emergencial: {
					celular_emergencia: '',
					grau_emergencia: '',
					nome_emergencia: '',
					telefone_emergencia: ''
				},
				tipo: ''
			}
		}
	},
	methods: {
		editar(dados) {
			this.$nextTick(() => {
				this.$refs.endereco_residencial.editar({
					item: dados,
					tipo: 'residencial'
				})
			})

			this.$nextTick(() => {
				this.$refs.endereco_funcional.editar({item: dados, tipo: 'funcional'})
			})

			this.$nextTick(() => {
				this.$refs.dados_adicionais.editar(dados)
			})
		},

		validaForm() {
			let passou = true
			if (!this.$refs.endereco_residencial.validaForm()) {
				passou = false
			}

			if (!this.$refs.endereco_funcional.validaForm()) {
				passou = false
			}

			if (!this.$refs.dados_adicionais.validaForm()) {
				passou = false
			}

			if (passou) {
				this.$emit('dados-usuario', {form: this.form})
			}

			return passou
		}
	}
}
</script>